import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/drug-group";

export const saveDrugGroup = drugGroup => axios.post(API_PATH + "/save", drugGroup);

export const getDrugGroupById = drugGroupId => axios.get(API_PATH + "/getbyid/" + drugGroupId);

export const pagingDrugGroup = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const deleteDrugGroup = drugGroupId => axios.delete(API_PATH + "/mark-delete/" + drugGroupId);

export const getAllDrugGroup = () => axios.get(API_PATH + "/get-all");

